'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            width: theme.width,
            minWidth: theme.minWidth,
            font: theme.tsNormal + '/' + theme.tlNormal + ' "' + theme.fontFamily + '"',
            borderCollapse: theme.borderCollapse,
            borderSpacing: theme.borderSpacing,

            '& > tbody': {
                '& > tr > td, & > tr > th': {
                    borderBottom: '1px solid ' + theme.tbodyTdBorderBottomColor,
                    fontSize: theme.tbodyTdFontSize,
                    lineHeight: theme.tbodyTdLineHeight,
                    textAlign: 'left',
                    verticalAlign: 'middle',
                    boxSizing: 'border-box'
                },

                '& > tr > th': {
                    background: theme.tbodyThBackgroundColor,
                    color: theme.tbodyThColor,
                    padding: theme.tbodyThPadding,
                    fontSize: theme.tbodyThFontSize,
                    lineHeight: theme.tbodyThLineHeight
                },

                '& > tr > td': {
                    color: theme.tbodyTdColor,
                    background: theme.tbodyTdBackgroundColor,
                    padding: theme.tbodyTdPadding,
                    height: theme.tbodyTdHeight
                },

                '& > tr:hover': {
                    '& > td': {
                        background: theme.tbodyTdHover
                    }
                }
            },

            '& > thead': {
                '& > tr > td, & > tr > th': {
                    fontSize: theme.theadFontSize,
                    lineHeight: theme.theadLineHeight,
                    fontWeight: theme.theadFontWeight,
                    textAlign: 'left',
                    padding: theme.theadPadding,
                    verticalAlign: 'middle',
                    boxSizing: 'border-box'
                },

                '& > tr > th': {
                    color: theme.theadThColor,
                    background: theme.theadThBackground
                },

                '& > tr > td': {
                    color: theme.theadTdColor,
                    background: theme.theadTdBackground
                }
            },

            '& > tfoot': {
                '& > tr > td, & > tr > th': {
                    fontSize: theme.tfootFontSize,
                    lineHeight: theme.tfootLineHeight,
                    textAlign: 'left',
                    verticalAlign: 'middle',
                    padding: theme.tfootPadding,
                    borderBottom: '0 none',
                    boxSizing: 'border-box'
                },

                '& > tr > th': {
                    color: theme.tfootThColor,
                    background: theme.tfootThBackground
                },

                '& > tr > td': {
                    color: theme.tfootTdColor,
                    background: theme.tfootTdBackground
                }
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        // tbody
        // tbodyTdBorderBottomColor: theme.elDivider,
        // без прозрачности, потому что хром некорректно делает border-collapse и рамки налазят друг на друга из-за чего меняют цвет
        tbodyTdBorderBottomColor: '#e0e0e0',
        tbodyTdColor: theme.tFilled,
        tbodyTdFontSize: theme.tsSmall,
        tbodyTdLineHeight: theme.tlSmall,
        tbodyTdBackgroundColor: 'transparent',
        tbodyTdPadding: theme.gutter + 'px',
        // 2x lineHeight + padding
        tbodyTdHeight: '60px',
        tbodyTdHover: theme.elPrimaryLight,

        tbodyThFontSize: theme.tsXSmall,
        tbodyThLineHeight: theme.tlXSmall,
        tbodyThBackgroundColor: theme.elLightest,
        tbodyThColor: theme.tInactive,
        tbodyThPadding: theme.gutter / 2 + 'px ' + theme.gutter + 'px',

        // thead
        theadFontSize: theme.tsXSmall,
        theadLineHeight: theme.tlXSmall,
        theadFontWeight: theme.twSemi,
        theadPadding: theme.gutter + 'px',
        theadTdColor: theme.tInactive,
        theadTdBackground: 'transparent',
        theadThBackground: theme.elPrimaryLight,
        theadThColor: theme.tInactive,

        // tfoot
        tfootFontSize: theme.tsXSmall,
        tfootLineHeight: theme.tlXSmall,
        tfootPadding: theme.gutter + 'px',
        tfootTdColor: theme.tLabel,
        tfootTdBackground: 'transparent',
        tfootThBackground: theme.elPrimaryLight,
        tfootThColor: theme.tLabel,

        borderCollapse: 'separate',
        borderSpacing: 0,
        width: '100%',
        minWidth: 'auto'
    };
};